var ButtonMessagePage = require("app/AppLayout/ButtonMessagePage"),
    frameThrottle     = require("enyo-perf/utils").frameThrottle,
    kind              = require("enyo/kind");

module.exports = kind(/** @lends  app.ArtistPage.ArtistNotFoundPageView.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.ArtistNotFoundPageView",

    /**
     * @private
     */
    kind: ButtonMessagePage,

    /**
     * @private
     */
    classes: "app-artist-page-artist-not-found-page-view",

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.ArtistPage.ArtistNotFoundError.title"));
        $message.$.body.set("content", i18nService.getString("app.ArtistPage.ArtistNotFoundError.body"));
        $message.$.button.set("caption", i18nService.getString("app.ArtistPage.ArtistNotFoundError.Button.caption"));
        $message.$.button.set("tooltip", i18nService.getString("app.ArtistPage.ArtistNotFoundError.Button.tooltip"));
    },

    /**
     * Go back to previous history state, that's the best we can do for now.
     *
     * @private
     */
    onMessageButtonTap: function() {
        this.app.$.router.back();
    }

});
